import { render, staticRenderFns } from "./OtherAssetsFS.vue?vue&type=template&id=1c512349&scoped=true"
import script from "./OtherAssetsFS.vue?vue&type=script&lang=ts"
export * from "./OtherAssetsFS.vue?vue&type=script&lang=ts"
import style0 from "./OtherAssetsFS.vue?vue&type=style&index=0&id=1c512349&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c512349",
  null
  
)

export default component.exports